import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import GetEBookButton from "./GetEBookButton";

const LifeChangingPracticeComponent = () => {
  return (
    <Container maxWidth="md" sx={{ textAlign: "center", py: 5 }}>
      {/* Headline */}
      <Box mb={4}>
        <Typography variant="h4" component="h3" gutterBottom fontFamily="Playfair Display" fontWeight={400} color="text.primary">
          <strong>It’s Not Just Pretty Pages, It’s Life-Changing Practice.</strong>
        </Typography>
        <Typography variant="h6" component="p"  color="text.secondary">
          Every page, prompt, and printable has been designed with one purpose:
        </Typography>
        <Typography variant="h6" component="p"  fontWeight={700} color="text.primary">
          to make emotional growth easy, joyful, and real for your family.
        </Typography>
      </Box>

      {/* Image */}
      <Box mb={4}>
        <img src={"/assets/group6-life-changing-practice.png"} alt="Life Changing Practice" style={{ maxWidth: "100%", height: "auto" }} />
      </Box>

      {/* Subheadline */}
      <Box mb={3}>
        <Typography variant="h5" component="h3"  fontWeight={400} color="text.primary">
          <strong>If you’ve ever wished parenting came with a roadmap,</strong>
        </Typography>
        <Typography variant="h5" component="h3"  fontWeight={400} color="text.primary">
          <strong>this is the one you should go for today.</strong>
        </Typography>
      </Box>

      <GetEBookButton   />

    </Container>
  );
};

export default LifeChangingPracticeComponent;
